import * as antlr from "antlr4ng";

export interface SyntaxError {
    line: number;
    column: number;
    message: string;
}

export class CustomErrorListener extends antlr.BaseErrorListener {
    public errors: SyntaxError[] = [];

    public override syntaxError(_recognizer: antlr.Recognizer<antlr.ATNSimulator>, _offendingSymbol: unknown, line: number, column: number, message: string): void {
        this.errors.push({ line, column, message });
    }
}
